import { useQuery } from "react-query";
import { loggedInApiCall } from "src/api/axiosClient/userApi";
import { zodParseWithDetailedLog } from "src/api/apiErrorLogs";
import { isQueryReady } from "src/api/axiosClient/utils";
import { PostListSchema } from "./types/postList.types";

export const getProductPostsKey = "getProductPosts" as const;

export const fetchProductPosts = async (
    productId: number,
    companyId?: number,
    campaignId?: number,
    itemsPerPage: number = 30,
) => {
    const url = `/api/products/${productId}/ssq-posts`;

    const response = await loggedInApiCall.get(url, {
        headers: {
            Accept: "application/json",
        },
        params: {
            organization_id: companyId ?? undefined,
            campaign: campaignId ?? undefined,
            itemsPerPage: itemsPerPage,
        },
    });

    const posts = response.data;
    const data = zodParseWithDetailedLog(posts, PostListSchema.array(), {
        operation: "GET",
        endpoint: "/products/:id/ssq-posts",
    });
    return data;
};

export const useGetProductPosts = (
    productId: number | undefined,
    companyId?: number,
    campaignId?: number,
    itemsPerPage: number = 30,
) => {
    const isEnabled = productId !== undefined && companyId !== undefined && campaignId !== undefined;
    const query = useQuery({
        cacheTime: 0,
        queryKey: [getProductPostsKey, productId, companyId, campaignId, itemsPerPage],
        enabled: isEnabled,
        keepPreviousData: false,
        queryFn: () => fetchProductPosts(productId!, companyId, campaignId, itemsPerPage),
    });

    const isReady = isQueryReady(query, isEnabled);

    return {
        productPosts: query.data ?? [],
        isReady,
        ...query,
    };
};
